// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"19e463d4","703":"6d11e369"}[chunkId] + ".chunk.js";
};